import { useMemo, useState } from "react";
import Combobox from "../forms/Combobox";

// The member picker of a project's Members card (pages/ProjectMembers.jsx): searches the active
// accounts (`accounts` = GET /api/users, [{id, username, full_name}], curators and admins only)
// by username or name, leaving out the ids in `exclude` (the current members). `onPick(account)`.
// The visible label and the accessible name are the same text (WCAG 2.5.3).

export const personLabel = p => (p.full_name ? `${p.full_name} (${p.username})` : p.username);

export default function MemberPicker({ id, accounts, exclude = [], onPick, disabled, label = "Find an account" }) {
  const [text, setText] = useState("");
  const options = useMemo(() => {
    const q = text.trim().toLowerCase();
    const out = new Set(exclude);
    return (accounts || []).filter(a => !out.has(a.id)
      && (!q || a.username.toLowerCase().includes(q) || (a.full_name || "").toLowerCase().includes(q)))
      .slice(0, 50);
  }, [accounts, exclude, text]);
  const status = accounts == null ? "Loading accounts…"
    : text.trim() ? `${options.length} account${options.length === 1 ? "" : "s"} found` : "";

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 240 }}>
      <label htmlFor={id} style={{ fontSize: 12, fontWeight: 600, color: "#374151", letterSpacing: "0.05em", textTransform: "uppercase" }}>
        {label}
      </label>
      <Combobox id={id} label={label} text={text} onText={setText} options={options}
                optionKey={a => a.id} listLabel="Accounts" status={status} disabled={disabled}
                placeholder="Username or name"
                renderOption={a => <span style={{ fontSize: 14 }}>{personLabel(a)}</span>}
                onPick={a => { setText(""); onPick(a); }} />
    </div>
  );
}
